// extracted by mini-css-extract-plugin
export default {"statusIcon":"foumRpflBC_"};